(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root && root.document) {
    root.NSB2BTracking = api;
    api.init(root);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var ALLOWED_PARAMS = [
    'page_path',
    'page_type',
    'link_host',
    'link_location',
    'cta_category'
  ];
  var VALID_EVENTS = [
    'quote_start',
    'project_inquiry_start',
    'project_inquiry_submit',
    'whatsapp_click',
    'email_click',
    'phone_click',
    'datasheet_download'
  ];

  function sanitizeParams(params) {
    return ALLOWED_PARAMS.reduce(function (safe, key) {
      if (params[key] !== undefined && params[key] !== '') {
        safe[key] = String(params[key]).slice(0, 120);
      }
      return safe;
    }, {});
  }

  function normalizeAction(input) {
    var href = input.href || '';
    var url;

    try {
      url = new URL(href, 'https://network-switch.com');
    } catch (error) {
      return null;
    }

    return {
      href: href,
      url: url,
      text: String(input.text || '').trim().toLowerCase(),
      dataset: input.dataset || {},
      pagePath: input.pagePath || '/',
      pageType: input.pageType || 'unknown',
      linkLocation: input.linkLocation || 'content'
    };
  }

  function result(name, action, category) {
    return {
      name: name,
      params: sanitizeParams({
        page_path: action.pagePath,
        page_type: action.pageType,
        link_host: action.url.hostname,
        link_location: action.linkLocation,
        cta_category: category
      })
    };
  }

  function classifyAction(input) {
    var action = normalizeAction(input);
    var explicit;
    var phonePath;

    if (!action) return null;

    explicit = action.dataset.nsTrack;
    if (VALID_EVENTS.indexOf(explicit) !== -1) {
      return result(explicit, action, 'explicit');
    }

    if (action.url.protocol === 'mailto:') {
      if (!/@network-switch\.com$/i.test(action.url.pathname)) return null;
      return result('email_click', action, 'email');
    }

    if (action.url.protocol === 'tel:') {
      return result('phone_click', action, 'phone');
    }

    if (
      action.url.hostname === 'wa.me' ||
      action.url.hostname === 'api.whatsapp.com'
    ) {
      phonePath = action.url.pathname.replace(/\D/g, '');
      if (!phonePath) return null;
      return result('whatsapp_click', action, 'whatsapp');
    }

    if (
      /\.pdf$/i.test(action.url.pathname) ||
      /data[\s-]?sheet|datasheet/.test(action.text) ||
      /\/pages\/data-sheet\/?$/.test(action.url.pathname)
    ) {
      return result('datasheet_download', action, 'datasheet');
    }

    if (action.href.indexOf('#chatty-chat') !== -1) {
      if (/quote|price|buy|stock/.test(action.text)) {
        return result('quote_start', action, 'quote');
      }
      return result('project_inquiry_start', action, 'chat');
    }

    if (
      action.dataset.openMfpAjax !== undefined ||
      action.dataset.id === 't4s-pr-popup__contact' ||
      /project inquiry|ask (an )?expert|technical support/.test(action.text)
    ) {
      return result('project_inquiry_start', action, 'project_inquiry');
    }

    if (/request (a )?quote|quote now|get (a )?quote/.test(action.text)) {
      return result('quote_start', action, 'quote');
    }

    return null;
  }

  function shouldEmitMarker(key, seen) {
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  }

  function init(win) {
    var doc = win.document;
    var script = doc.currentScript;
    var pageType = (script && script.dataset.pageType) || 'unknown';
    var seenMarkers = new Set();
    var debugEvents = [];
    var debugPanel;

    function locationFor(element) {
      if (element.closest('header')) return 'header';
      if (element.closest('footer')) return 'footer';
      if (element.closest('[class*="product"]')) return 'product';
      return 'content';
    }

    function renderDebugEvent(entry) {
      var line;

      if (!debugPanel) return;
      line = doc.createElement('div');
      line.textContent = entry.name + ' | ' + entry.params.link_location;
      debugPanel.appendChild(line);
    }

    function send(name, params) {
      var safeParams = sanitizeParams(params);
      var entry = { name: name, params: safeParams };

      debugEvents.push(entry);
      renderDebugEvent(entry);
      if (typeof win.gtag === 'function') {
        win.gtag('event', name, safeParams);
      }
    }

    function processMarker(marker) {
      var name = marker.dataset.nsGa4Event;
      var key = name + ':' + (marker.dataset.nsGa4Key || 'default');
      var storageKey = 'ns_ga4_marker:' + key;

      if (VALID_EVENTS.indexOf(name) === -1) return;
      if (win.sessionStorage && win.sessionStorage.getItem(storageKey)) return;
      if (!shouldEmitMarker(key, seenMarkers)) return;

      if (win.sessionStorage) win.sessionStorage.setItem(storageKey, '1');
      send(name, {
        page_path: win.location.pathname,
        page_type: pageType,
        link_location: 'form',
        cta_category: 'confirmed_submit'
      });
    }

    function scanMarkers(rootNode) {
      var markers = [];

      if (rootNode.matches && rootNode.matches('[data-ns-ga4-event]')) {
        markers.push(rootNode);
      }
      if (rootNode.querySelectorAll) {
        markers = markers.concat(
          Array.prototype.slice.call(
            rootNode.querySelectorAll('[data-ns-ga4-event]')
          )
        );
      }
      markers.forEach(processMarker);
    }

    function setupDebugPanel() {
      var params = new URLSearchParams(win.location.search);

      if (
        params.get('ns_ga_debug') !== '1' ||
        !params.get('preview_theme_id')
      ) {
        return;
      }

      debugPanel = doc.createElement('aside');
      debugPanel.setAttribute('aria-label', 'GA4 preview events');
      debugPanel.style.cssText =
        'position:fixed;right:12px;bottom:12px;z-index:2147483647;' +
        'width:min(320px,calc(100vw - 24px));max-height:220px;overflow:auto;' +
        'padding:12px;background:#111;color:#fff;border:1px solid #8cc63f;' +
        'border-radius:6px;font:12px/1.5 monospace;box-shadow:0 4px 16px #0004;';
      debugPanel.textContent = 'GA4 preview events';
      doc.body.appendChild(debugPanel);
      debugEvents.forEach(renderDebugEvent);
    }

    doc.addEventListener('click', function (event) {
      var element = event.target.closest('a,button');
      var action;

      if (!element) return;
      action = classifyAction({
        href: element.getAttribute('href') || '',
        text: element.textContent || element.getAttribute('aria-label') || '',
        dataset: element.dataset,
        pagePath: win.location.pathname,
        pageType: pageType,
        linkLocation: locationFor(element)
      });
      if (action) send(action.name, action.params);
    });

    function start() {
      setupDebugPanel();
      scanMarkers(doc);
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes, scanMarkers);
        });
      }).observe(doc.documentElement, { childList: true, subtree: true });
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  }

  return {
    classifyAction: classifyAction,
    sanitizeParams: sanitizeParams,
    shouldEmitMarker: shouldEmitMarker,
    init: init
  };
});
